export interface EDCurriculum {
  // DB Fields
  uid: number;
  companyUID: number; // 업체 UID
  category1UID: number; // 대분류 UID
  category2UID: number; // 중분류 UID
  category3UID: number; // 세분류 UID
  tutorUID: number; // 강사 UID
  contents: string; // Deprecated
  duration: number; // Deprecated
  isHour: boolean; // Deprecated
  textBookFile: string; // 교안등록 파일명
  hasNotExam: boolean; // 응시/미응시 여부 - 미응시 - true
  maxTrialCount: number; // 최대 응시 횟수
  minusPoint: number; // 감점 폭
  isDeleted: boolean; // 삭제 여부
  timeLimit: number; // 시험 시간 제한
  originDate: Date | string; // 시험 기준일

  hasNotOriginDate: boolean; // Deprecated
  termMonth: number; // Deprecated
  hasNotEvalSetting: boolean; // Deprecated
  startDay: number; // Deprecated
  endDay: number; // Deprecated
  hour: number; // Deprecated
  minute: number; // Deprecated
  cutLine: number; // Deprecated
  retryCutLine: number; // Deprecated
  place: string; // Deprecated
  educationMethod: string; // Deprecated

  departments: string[]; // 대상 부서
  excludes: string[]; // 제외 여부 
  // includeUIDs: number[]; // 시험 대상자 UID
  isNewVersion: boolean; // 최신 버전 여부

  // NOT DB
  year: number;
  month: number;
  departmentsUIDs: number[]; // 대상 부서 UID 목록
  allTrialCount: number; // 평가자
  allExamerCount: number; // 대상자
  allScoreAverage: number; // 평균점수
  base64: string; //교안등록 base64
}

export const initializeCurriculum: EDCurriculum = {
  // DB Fields
  uid: 0,
  companyUID: 0,
  category1UID: 0,
  category2UID: 0,
  category3UID: 0,
  tutorUID: 0,
  contents: "", // Deprecated
  duration: 0, // Deprecated
  isHour: false, // Deprecated
  textBookFile: "",
  hasNotExam: false,
  maxTrialCount: 0,
  minusPoint: 1,
  isDeleted: false,
  timeLimit: 0,
  originDate: new Date(),

  hasNotOriginDate: false, // Deprecated
  termMonth: 0, // Deprecated
  hasNotEvalSetting: false, // Deprecated
  startDay: 0, // Deprecated
  endDay: 0, // Deprecated
  hour: 0, // Deprecated
  minute: 0, // Deprecated
  cutLine: 0, // Deprecated
  retryCutLine: 0, // Deprecated
  place: "", // Deprecated
  educationMethod: "", // Deprecated

  year: new Date().getFullYear(),
  month: new Date().getMonth() + 1,
  departments: [] as string[],
  excludes: [] as string[],
  departmentsUIDs: [] as number[],
  allTrialCount: 0,
  allExamerCount: 0,
  allScoreAverage: 0,

  // includeUIDs: [], // 시험 대상자 UID
  isNewVersion: false, // 최신 버전 여부

  base64: "",
};

export interface CurriculumListParams {
  page: number;
  token: string;
  rows?: number; // 표시 행 수
  filterDepth1UID: number; // 대분류 UID
  filterDepth2UID?: number; // 중분류 UID
  filterDepth3UID?: number; // 소분류 UID
  departmentUID?: number; // 부서 UID

  searchStartDate?: Date | null; // 검색 시작일
  searchEndDate?: Date | null; // 검색 종료일
}
export const initialCurriculumListParams = {
  page: 1,
  token: "",
  rows: 20, // 표시 행 수
  filterDepth1UID: 0, // 대분류 UID
  filterDepth2UID: 0, // 중분류 UID
  filterDepth3UID: 0, // 소분류 UID
  departmentUID: 0, // 부서 UID

  searchStartDate: null, // 검색 시작일
  searchEndDate: null, // 검색 종료일
};
